import React from 'react';
import { FormGroup, InputGroup, Input, InputGroupText } from 'reactstrap';
import { SmallFormFeedback } from '../../../../utils/budget-tool-specific';
import { RebelColors } from '../../../../styles/rebel-experiences';
import styled from 'styled-components';

const RebelFormInput = (props) => {
    const [isHovered, setIsHovered] = React.useState(false);

    const handleInputChange = (value) => {
        const newData = {...props.data};
        newData[props.id].value = value;
        if (props.dataSanitation !== undefined){
            props.dataSanitation(newData, props.dataSanitationParams);
        }
        props.setData(newData);
    }

    const toggle = () => {
        props.toggleAction(!props.toggleValue);
    }

    return (
        <React.Fragment>
            {<FormGroup>
                <RebelLabel for={props.id}>{props.title}</RebelLabel>
                <InputGroup>
                    {props.currency && <RebelInputGroupText>{props.currency}</RebelInputGroupText> }
                    <RebelInput
                        invalid={props.data[props.id].invalid}
                        type={props.type}
                        disabled={props.client}
                        value={props.data[props.id].value}
                        onChange={e => handleInputChange(e.target.value)}
                        fontSize={props.fontSize ? props.fontSize : "16px"}
                        readOnly={props.type !== "select" && props.client}>
                        {props.options}
                    </RebelInput>
                    {props.contingency && !props.labelCanBeToggled && <RebelInputGroupText>{props.labelIsDollar ? "$" : "%"}</RebelInputGroupText> }
                    {props.contingency && props.labelCanBeToggled && <RebelInputGroupText
                       style={{
                        backgroundColor: isHovered ? RebelColors.gold : RebelColors.surfaceLight,
                        color: isHovered ? '#000000' : RebelColors.text,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        minHeight: '46px',
                        height: '46px',
                        padding: '0 16px'
                      }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      onClick={props.onClick}>
                            {props.labelIsPercentage ? "%" : "$"}</RebelInputGroupText> }
                    <RebelFormFeedback>Required</RebelFormFeedback>
                    {props.toggle && <InputGroupText
                        style={{marginRight:"1px", backgroundColor: RebelColors.surface, border:"none", fontSize:"12px", color: RebelColors.text}}>
                        {props.toggleTitle}
                    </InputGroupText>}
                    {props.toggle && <Input
                        addon
                        aria-label="Checkbox for following text input"
                        type="checkbox"
                        checked={props.toggleChecked}
                        value = {props.toggleValue}
                        onChange={() => toggle()}
                    />}
                </InputGroup>
            </FormGroup> }
        </React.Fragment>
    )
}

export default RebelFormInput;

const RebelLabel = styled.label`
    color: ${RebelColors.gold};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 0.95rem;
    display: block;
`;

const RebelInput = styled(Input)`
    font-size: ${props => props.fontSize ? props.fontSize : "16px"};
    margin: ${props => props.fontSize === "16px" ? "" : "0px 0px"};
    border: 1px solid ${RebelColors.border};
    border-radius: 0 !important;
    background-color: #3b3f45;
    color: ${RebelColors.text} !important;
    padding: ${props => props.fontSize === "30px" ? "12px 16px" : "10px 16px"};
    min-height: 46px;
    transition: all 0.3s ease;

    /* When input is alone (no siblings), apply full border radius */
    &:only-child {
        border-radius: 6px !important;
    }

    /* When input is first in group (has sibling after) */
    &:first-child:not(:only-child) {
        border-radius: 6px 0 0 6px !important;
    }

    /* When input is last in group (has sibling before) */
    &:last-child:not(:only-child) {
        border-radius: 0 6px 6px 0 !important;
    }

    /* When input is in the middle */
    &:not(:first-child):not(:last-child) {
        border-radius: 0 !important;
    }

    &:focus {
        background-color: #424752;
        border-color: ${RebelColors.gold} !important;
        box-shadow: none !important;
        color: ${RebelColors.text} !important;
        outline: none !important;
    }

    &::placeholder {
        color: ${RebelColors.primaryMuted};
    }

    &:hover {
        border-color: ${RebelColors.borderLight};
        background-color: #424752;
    }

    &:disabled {
        background-color: ${RebelColors.surface};
        color: ${RebelColors.primaryMuted} !important;
        cursor: not-allowed;
    }

    &:read-only:not([type="select-one"]) {
        background-color: ${RebelColors.surface};
        color: ${RebelColors.primaryMuted} !important;
        cursor: not-allowed;
    }

    /* Force pointer cursor for all selects that are not disabled */
    &[type="select-one"] {
        cursor: pointer !important;
    }

    select& {
        cursor: pointer !important;
    }

    &:is(select) {
        cursor: pointer !important;
    }

    /* Override any disabled styles for selects specifically when not actually disabled */
    &[type="select-one"]:not([disabled]) {
        cursor: pointer !important;
        background-color: #3b3f45;
    }

    option {
        background-color: #3b3f45;
        color: ${RebelColors.text};
    }
`;

const RebelInputGroupText = styled(InputGroupText)`
    background-color: #2a2e34;
    border: 1px solid ${RebelColors.border};
    color: ${RebelColors.text};
    border-radius: 0 !important;
    padding: 10px 16px;
    min-height: 46px;
    display: flex;
    align-items: center;

    /* When it's first in group */
    &:first-child {
        border-radius: 6px 0 0 6px !important;
        border-right: none;
    }

    /* When it's last in group */
    &:last-child {
        border-radius: 0 6px 6px 0 !important;
        border-left: none;
    }
`;

const RebelFormFeedback = styled(SmallFormFeedback)`
    color: ${RebelColors.danger};
`;
